import { render } from "./TicketDesign.vue?vue&type=template&id=01cbc606&scoped=true"
import script from "./TicketDesign.vue?vue&type=script&lang=js"
export * from "./TicketDesign.vue?vue&type=script&lang=js"

import "./TicketDesign.vue?vue&type=style&index=0&id=01cbc606&scoped=true&lang=css"

import exportComponent from "/var/www/intercity.dev-jatri.jatritech.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01cbc606"]])

export default __exports__